export default function programData($http) {
    return {
        init: id => $http.get('/webapi/programfilter/get/' + id)
            .then(resp => resp.data)
    };
}
